import type { WizardStep } from "../views/NewConfigurationWizard";

const PROJECT_FIELDS = new Set([
  "projectNumber",
  "projectName",
  "customer",
  "engineer",
  "projectRevision",
  "configurationDate",
]);

const PIPE_FIELDS = new Set([
  "outsideDiameter",
  "outsideDiameterUnit",
  "wallThickness",
  "wallThicknessUnit",
  "pipeGrade",
  "pipeLength",
  "pipeLengthUnit",
  "pipeTolerance",
  "pipeGeometry",
  "cutbackLongSide",
  "cutbackLongSideUnit",
  "cutbackShortSide",
  "cutbackShortSideUnit",
  "cutbackPlusTolerance",
  "cutbackMinusTolerance",
  "chamferAngleDeg",
  "chamferPlusToleranceDeg",
  "chamferMinusToleranceDeg",
  "cwcCutbackLongSide",
  "cwcCutbackShortSide",
  "ppToeLength",
  "ppToeThickness",
  "coatingPlusTolerance",
  "coatingMinusTolerance",
  "overlapOnFbe",
]);

const PROCESS_FIELDS = new Set([
  "coatingType",
  "coatingThickness",
  "coatingThicknessUnit",
  "heatingRequirement",
  "blastRequirement",
  "surfacePreparation",
]);

export const wizardStepForField = (field: string): WizardStep => {
  if (PROJECT_FIELDS.has(field)) return "project";
  if (PIPE_FIELDS.has(field)) return "pipe";
  if (PROCESS_FIELDS.has(field)) return "process";
  return "review";
};
